import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { racesAPI } from '../services/api';
import RaceCountdown from '../components/RaceCountdown';

function Races() {
  const navigate = useNavigate();
  const [races, setRaces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('upcoming');

  useEffect(() => {
    const loadRaces = async () => {
    try {
      setLoading(true);
      const params = filter === 'all' ? {} : { status: filter };
      const response = await racesAPI.getRaces(params);
      
      if (response.success) {
        setRaces(response.data.races || []);
      }
    } catch (error) {
      console.error('Failed to load races:', error);
    } finally {
      setLoading(false);
    }
    };
    loadRaces();
  }, [filter]);

  if (loading) {
    return <div className="loading">Loading races...</div>;
  }

  return (
    <div className="races-page">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
        <h2>Horse Races</h2>
        
        <div>
          <label htmlFor="filter" style={{ marginRight: '0.5rem' }}>Filter:</label>
          <select
            id="filter"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            style={{
              padding: '0.5rem',
              borderRadius: '4px',
              border: '1px solid #ddd',
              fontSize: '1rem',
            }}
          >
            <option value="upcoming">Upcoming</option>
            <option value="completed">Completed</option>
            <option value="all">All</option>
          </select>
        </div>
      </div>

      {races.length === 0 ? (
        <div className="card">
          <p style={{ color: '#666', textAlign: 'center' }}>
            No {filter} races available.
          </p>
        </div>
      ) : (
        <div className="races-grid">
          {races.map((race) => (
            <div
              key={race.raceId}
              className="race-card"
              onClick={() => navigate(`/races/${race.raceId}`)}
            >
              <h3>{race.raceName}</h3>
              <p className="race-info">📍 {race.venue}, {race.location}</p>
              <p className="race-info">
                📅 {new Date(race.raceDate).toLocaleDateString()} at{' '}
                {new Date(race.raceDate).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </p>
              {race.status === 'upcoming' && (
                <p className="race-info">
                  <RaceCountdown raceDate={race.raceDate} />
                </p>
              )}
              <p className="race-info">🏁 Distance: {race.distance}</p>
              <p className="race-info">🐎 {race.horses?.length || 0} horses</p>
              
              {race.status === 'upcoming' && (
                <p className="race-info" style={{ fontSize: '0.85rem', color: '#f57c00' }}>
                  ⏰ Pick deadline: {new Date(race.pickDeadline).toLocaleString()}
                </p>
              )}
              
              <span className={`race-status ${race.status}`}>
                {race.status}
              </span>
              
              {race.results?.winner && (
                <div style={{ marginTop: '0.5rem', paddingTop: '0.5rem', borderTop: '1px solid #eee' }}>
                  <p style={{ margin: 0, fontSize: '0.9rem', fontWeight: 'bold', color: '#4CAF50' }}>
                    🏆 Winner: {race.results.winner.horseName}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Races;
